import React from 'react';
import _ from 'lodash';
import Helmet from 'react-helmet';

import _masterSlideLoader from '../utilities/masterSlideLoader';
import LocalStorageService from '../services/utilities/LocalStorageService';
import {
  HEADER_CONSTANTS, // ヘッダータイトル
  JOINING_FLAG,
  ONE_MASTER_FLAG,
  CORPORATION_PERSONAL_NAME,
  CORPORATION_PERSONAL_KANA,
} from '../utilities/constants';
import { CompanyBranchService } from '../services/CompanyBranches'; // 協力会社API
import { MasterPageHeader } from '../components/PageHeader';
import {
  PreviewFormText,
  PreviewFormTel,
  PreviewFormImage,
} from '../components/PreviewForm';
import { convertFlagToCircleOrCross } from '../utilities/stringUtil';
import {
  getLegalPersonalitiesById,
  getPrefectureGroupById,
} from '../utilities/constantsUtil';
import { getLabelPersonalCompanyType } from '../utilities/partnerCompanyUtil';
import { messageUtility } from '../utilities/messageUtility';
/**
 * 協力会社詳細
 * 画面遷移
 *  - 本社管理者でログイン > 協力会社一覧 > 協力会社データ行 確認ボタン
 */
export class PartnerCompanyPreview extends React.Component {
  constructor(props) {
    super(props);

    // パラメータ分解
    const param = this.props.view.state.id.split('.');

    this.state = {
      // ユーザーロール
      roleId: LocalStorageService.getRoleId(),
      partnerCompanyId: param[0], // 協力会社ID
      companyBranchId: param[1], // 支店ID
      company: {}, // 会社（編集ボタンの表示のため）
      isCommonHojin: false,
      formValues: {
        name: '', // 会社名
        kana: '', // 会社名かな
        juridical_personality_code: '', // 法人格
        postal_code: '', // 郵便番号
        prefectures_code_id: '', // 都道府県
        city_name: '', // 市区町村
        street_number: '', // 丁目・番地
        building_name: '', // 建物名・部屋番号
        tel: '', // 電話番号
        fax: '', // FAX
        update_username: '', // 更新ユーザー
        updated_at: '', // 更新日時
        icon_image: '', // 会社ロゴ
        common_partner_company_code: '', // 協力会社コード
        joining_flag: '', // Buildee利用
        company_branch: {
          // 支店情報
          name: '', // 支店名
          kana: '', // 支店名かな
        },
        passWardChangeFlg: false,
        one_owner_flag: null,
      },
      users: null,
      isPerson: false, //個人協力会社(一人親方)かどうか
    };
  }

  componentDidMount() {
    const { partnerCompanyId, companyBranchId } = this.state;
    const param = { company_branch_id: companyBranchId };

    // フォームに値セット
    CompanyBranchService.show(partnerCompanyId, param).then(
      ({ result, data }) => {
        if (result) {
          this.initForm(data.entities);
        }
      }
    );
  }

  /**
   * フォーム生成
   * @param data {object} 会社情報
   */
  initForm = data => {
    const formValues = _.cloneDeep(this.state.formValues);
    formValues.name = data.company.name;
    formValues.kana = data.company.kana;
    formValues.juridical_personality_code =
      data.company.juridical_personality_code;

    formValues.joining_flag = data.company
      ? `${data.company.joining_flag}`
      : '';
    formValues.common_partner_company_code = data.common_partner_company_code;
    formValues.company_branch.id = data.company_branch.id;

    // 支店情報あり
    if (!_.isNaN(data.company_branch)) {
      formValues.company_branch.name = data.company_branch.name;
      formValues.company_branch.kana = data.company_branch.kana;
    }

    formValues.postal_code = data.company.postal_code;
    formValues.prefectures_code_id = data.company.prefectures_code_id;
    formValues.city_name = data.company.city_name;
    formValues.street_number = data.company.street_number;
    formValues.building_name = data.company.building_name;
    formValues.tel = data.company.tel;
    formValues.fax = data.company.fax;
    formValues.update_username = data.company.update_username;
    formValues.updated_at = data.company.updated_at;
    formValues.branch_name = 'branch_name';
    formValues.one_owner_flag = data.company.one_owner_flag;

    const isCommonHojin = this.isCommonHojin(data.company);
    const isPerson =
      ONE_MASTER_FLAG.personal.id === data.company.one_master_flag;
    const companyNumber = data.company.company_number;
    this.setState({
      image: data.icon_image_url,
      formValues,
      users: data.users,
      isCommonHojin,
      isPerson,
      companyNumber,
    });
  };

  isCommonHojin = company => {
    const { joining_flag, one_master_flag } = company;
    return (
      joining_flag === 1 && (one_master_flag === null || one_master_flag === 0)
    );
  };

  render() {
    const {
      users,
      isPerson,
      formValues,
      image,
      isCommonHojin,
      companyNumber,
    } = this.state;
    const passWordChange = () => {
      const result = [];
      _.map(users, user => {
        if (user.password_reset_notice_flag) {
          result.push(`${user.name_sei} ${user.name_mei}`);
        }
      });
      return result;
    };

    return (
      <div id='slide-view' className='contruction-slide-view show'>
        <Helmet>
          <title>{HEADER_CONSTANTS.title} - 協力会社詳細</title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <MasterPageHeader
            title='協力会社詳細'
            onClose={() =>
              _masterSlideLoader.show('PartnerCompanies', { state: {} })
            }
          />
          <div className='contruction-slide-view__body partner_company_preview'>
            <div className='contruction-detail-view'>
              <div className='contruction-detail-view__sidemenu'>
                <ul className='contruction-navi-list'>
                  <li className='contruction-navi-list__item'>
                    <div className='line-list line-list--contruction-navi-list select'>
                      基本情報
                    </div>
                  </li>
                </ul>
              </div>
              <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                <div className='contruction-detail-view__header'>
                  <button
                    className='btn-text--sm'
                    onClick={() =>
                      _masterSlideLoader.show('PartnerCompanies', { state: {} })
                    }
                  >
                    <i className='i-back--blue i-2x vertical-middle' />
                    協力会社一覧
                  </button>
                </div>
                <div className='contruction-detail-view__bar' />
                <div className='contruction-detail-view__main contruction-detail-view__main--fixed contruction-detail-view__main--fix'>
                  <ul className='form-list form-list-default'>
                    <PreviewFormText
                      label='種別'
                      values={[
                        isPerson
                          ? ONE_MASTER_FLAG.personal.name
                          : isCommonHojin
                          ? ONE_MASTER_FLAG.corporation.name
                          : '',
                      ]}
                    />
                    {isPerson && (
                      <PreviewFormText
                        label={messageUtility.getMessage('I-000-186')}
                        values={[
                          getLabelPersonalCompanyType(
                            formValues.one_owner_flag
                          ),
                        ]}
                      />
                    )}
                    <PreviewFormText
                      label={
                        isPerson
                          ? CORPORATION_PERSONAL_NAME.personal_name
                          : CORPORATION_PERSONAL_NAME.corporation_name
                      }
                      values={[formValues.name]}
                    />
                    <PreviewFormText
                      label={
                        isPerson
                          ? CORPORATION_PERSONAL_KANA.personal_kana
                          : CORPORATION_PERSONAL_KANA.corporation_kana
                      }
                      values={[formValues.kana]}
                    />
                    {isCommonHojin && (
                      <PreviewFormText
                        label='法人格'
                        values={[
                          getLegalPersonalitiesById(
                            formValues.juridical_personality_code
                          ),
                        ]}
                      />
                    )}
                    {isCommonHojin && (
                      <PreviewFormText
                        label='法人番号'
                        values={[companyNumber]}
                      />
                    )}
                    {formValues.joining_flag ===
                      JOINING_FLAG.contractorInherent.id && (
                      <React.Fragment>
                        <PreviewFormText
                          label='支店名'
                          values={[formValues.company_branch.name]}
                        />
                        <PreviewFormText
                          label='支店名ふりがな'
                          values={[formValues.company_branch.kana]}
                        />
                      </React.Fragment>
                    )}
                    <PreviewFormTel
                      label='郵便番号'
                      values={[formValues.postal_code]}
                    />
                    <PreviewFormText
                      label='都道府県'
                      values={[
                        getPrefectureGroupById(formValues.prefectures_code_id),
                      ]}
                    />
                    <PreviewFormText
                      label='市区町村'
                      values={[formValues.city_name]}
                    />
                    <PreviewFormText
                      label={messageUtility.getMessage('I-000-188')}
                      values={[formValues.street_number]}
                    />
                    <PreviewFormText
                      label='建物名・部屋番号等'
                      values={[formValues.building_name || '']}
                    />
                    <PreviewFormTel
                      label='電話番号'
                      values={[formValues.tel]}
                    />
                    <PreviewFormTel label='FAX番号' values={[formValues.fax]} />
                    <PreviewFormImage
                      label={isPerson ? 'ロゴ' : '会社ロゴ'}
                      imgUrl={image}
                    />
                    <PreviewFormText
                      label='共通化状態'
                      values={[
                        convertFlagToCircleOrCross(
                          String(formValues.joining_flag)
                        ),
                      ]}
                    />
                    <PreviewFormText
                      label='職長パスワードリセット通知先'
                      values={[passWordChange()]}
                    />
                    <PreviewFormText
                      label='更新ユーザー'
                      values={[formValues.update_username]}
                    />
                    <PreviewFormText
                      label='更新日時'
                      values={[formValues.updated_at]}
                    />
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/PartnerCompanyPreview.jsx